import axios from "axios";
import setAuthToken from "../auth/aut-headers";


import {BASE_API_URL} from '../base_url'

const API_URL = BASE_API_URL + "/api/standeditor";



class StandeditorService {

  getBaseURL(){
    return API_URL
  }

  getplan(planId:number) {
    return axios
      .get(API_URL + "/" + planId, {
        params:{
           
        }
      })
      .then(response => {
        return response.data;
      });
  }

  getplanbackground(planId:number) {
    return axios
      .get(API_URL + "/background/" + planId, {
        params:{
           
        }
      })
      .then(response => {
        return response.data;
      });
  }

  savePlanBackground(plan_id:number, image_name:string, image_data:string){
    
    return axios
      .post(API_URL + "/uploadbackground", {
        plan_id : plan_id,
        image_name:image_name,
        image_data: image_data
      })
      .then(response => {
        return response;
      });
  }

  

  getplandata(planId:number, lang:string | undefined='pl') {
    return axios
      .get(API_URL + "/data/" + planId, {
        params:{
           lang:lang
        }
      })
      .then(response => {
        return response.data;
      });
  }

  saveplan(plan_id: number, data:any, close_edit : number) {
    //console.log(query)
    return axios
      .put(API_URL, {plan_id : plan_id, data: data, close_edit : close_edit})
      .then(response => {
        return response;
      });
  }



  getbackuplist(plan_id: number) {
    //console.log(query)
    return axios
      .get(API_URL + '/getbackuplist/'+ plan_id)
      .then(response => {
        return response;
      });
  }

  restorebackup(plan_id: number, backupFileName: string) {
    //console.log(query)
    return axios
      .post(API_URL + '/restorebackup',  {plan_id : plan_id, backupFileName : backupFileName})
      .then(response => {
        return response;
      });
  }

  startedit(plan_id: number) {
    //console.log(query)
    return axios
      .post(API_URL + '/startedit/'+plan_id)
      .then(response => {
        return response;
      });
  }

  canceledit(plan_id: number) {
    //console.log(query)
    return axios
      .post(API_URL + '/canceledit/'+plan_id)
      .then(response => {
        return response;
      });
  }
  
  checkactivityedit(plan_id: number) {
    //console.log(query)
    return axios
      .post(API_URL + '/checkactivityedit/'+plan_id)
      .then(response => {
        return response;
      });
  }

  setactivityedit(plan_id: number) {
    //console.log(query)
    return axios
      .post(API_URL + '/setactivityedit/'+plan_id)
      .then(response => {
        return response;
      });
  }

  standstatusupdate( action_FORM: string, stand_STATUS: string, email: string,
                    plan_ID: number, plan_NAME: string, stand_NR: string, stand_NAME: string){
    //console.log(query)
    return axios
      .post(API_URL + '/standstatusupdate', {action_FORM: action_FORM, stand_STATUS: stand_STATUS, email: email,
        plan_ID: plan_ID, plan_NAME: plan_NAME, stand_NR: stand_NR, stand_NAME: stand_NAME})
      .then(response => {
        return response;
      });
  }

  clonstand(action_FORM: string, stand_TEMP: string, stand_COLOR: string){
    return axios
      .post(API_URL + '/clonstand', {action_FORM: action_FORM, stand_TEMP: stand_TEMP, stand_COLOR: stand_COLOR})
      .then(response => {
        return response;
      });
  }


  newstand( action_FORM: string, stand_NAME: string, stand_NR: string,
    stand_W : number, stand_H : number, stand_COLOR: string){
    //console.log(query)
    return axios
    .post(API_URL + '/newstand', {action_FORM: action_FORM, stand_NAME: stand_NAME, stand_NR:stand_NR,
      stand_W : stand_W, stand_H : stand_H, stand_COLOR : stand_COLOR}
    ).then(response => {
      return response;
    });
  }

  
  setWallColor(plan_id: number, color:string){
    return axios
    .post(API_URL + '/setWallColor', {plan_id: plan_id, color: color}
    ).then(response => {
      return response;
    });
  }

  savebackgroundposition(plan_id: number, background_position: string) {
    //console.log(query)
    return axios
      .post(API_URL + '/savebackgroundposition',  {plan_id : plan_id, background_position : background_position})
      .then(response => {
        return response;
      });
  }

 

}

export default new StandeditorService();